






































import { Component, Prop, Vue, Inject } from "vue-property-decorator";

import { IHeightStyle } from "@/@types/styles/height";
import { preferred_language } from "@/config/languags.config.json";

@Component({})
export default class MenuDemo extends Vue {
  @Prop({ type: String, default: "" }) name!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) alert!: string;
  @Prop({ type: String, default: "" }) img!: string;
  @Prop({ type: String, default: preferred_language }) language!: string;
  @Inject({ from: "bgFolder", default: null }) readonly bgFolder!: string;

  show = false;
  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
  }

  mounted(): void {
    setTimeout(() => this.calculateHeight(), this.$second(0.3));
  }
}
